import { combineReducers } from 'redux';

import { reducer as loginUrl } from './loginUrlModule';

export default combineReducers({
	loginUrl,
});
